import React, { useEffect, useState, useRef } from 'react';
import { FaTimes } from 'react-icons/fa';
import styles from './NewFirstScreen.module.css';
import racheli from "../images/רחלי לוי תדמית ללא רקע.webp";
import Loader from '../components/loader/Loader';
import PrivacyPolicy from '../components/privacy/Privacy';

const NewFirstScreen = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [imageLoaded, setImageLoaded] = useState(false);
  const bgImageTopRef = useRef(null);
  const bgImageBottomRef = useRef(null);

  // State for form
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [errors, setErrors] = useState({
    fullName: '',
    phone: '',
    reason: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [agreed, setAgreed] = useState(false);

  // Refs for form fields
  const fullNameRef = useRef(null);
  const phoneRef = useRef(null);
  const reasonRef = useRef(null);

  // Server settings
  const serverUrl = "https://dynamic-server-dfc88e1f1c54.herokuapp.com/leads/newLead";
  const zapierWebhookUrl = "https://hooks.zapier.com/hooks/catch/12851209/bjclnzb/";
  const reciver = "pedimenihanala@gmail.com";

  const handleButtonClick = () => {
    setIsFormOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeForm = () => {
    setIsFormOpen(false);
    document.body.style.overflow = 'auto';
    if (!submitted) {
      if (fullNameRef.current) fullNameRef.current.value = "";
      if (phoneRef.current) phoneRef.current.value = "";
      if (reasonRef.current) reasonRef.current.value = "";
      setErrors({
        fullName: '',
        phone: '',
        reason: ''
      });
      setAgreed(false);
    }
  };

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const name = fullNameRef.current.value;
    const phone = phoneRef.current.value;
    const reason = reasonRef.current.value;
    
    if (!agreed) {
      alert("עליך לאשר את תנאי השימוש ומדיניות הפרטיות");
      return;
    }
    
    let valid = true;
    const newErrors = { ...errors };

    if (!name.trim()) {
      newErrors.fullName = 'נא להזין שם מלא';
      valid = false;
    } else if (name.trim().length < 2) {
      newErrors.fullName = 'שם חייב להכיל לפחות 2 תווים';
      valid = false;
    } else {
      newErrors.fullName = '';
    }

    const phoneRegex = /^0(5\d|[23489])\d{7}$/;
    if (!phone.trim()) {
      newErrors.phone = 'נא להזין מספר טלפון';
      valid = false;
    } else if (!phoneRegex.test(phone.trim())) {
      newErrors.phone = 'נא להזין מספר טלפון תקין';
      valid = false;
    } else {
      newErrors.phone = '';
    }

    if (!reason.trim()) {
      newErrors.reason = 'נא להזין סיבת פנייה';
      valid = false;
    } else if (reason.trim().length < 5) {
      newErrors.reason = 'נא להזין לפחות 5 תווים';
      valid = false;
    } else {
      newErrors.reason = '';
    }

    setErrors(newErrors);
    
    if (!valid) {
      return;
    }
    
    setIsSubmitting(true);
    
    const serverData = {
      name: name,
      phone: phone,
      reason: reason,
      reciver: reciver
    };

    const formData = new FormData();
    formData.append('firstName', name.trim());
    formData.append('lastName', '.');
    formData.append('cellPhone', phone.trim());
    formData.append('interest', 'קורס דיגיטלי מיקרובליידינג');
    formData.append('campaign', 'אתר רחלי לוי');
    formData.append('authorization', 'K+OhgLhZTCxObekZWw3D4Xh6V+1VarEGMbsqvcB4+ZhFQCrDbcyyCfHSOY0+dVqU');
    
    try {
      const [serverResponse, zapierResponse] = await Promise.allSettled([
        fetch(serverUrl, {
          method: "POST",
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(serverData)
        }),
        fetch(zapierWebhookUrl, {
          method: "POST",
          body: formData
        })
      ]);
      
      const serverSuccess = serverResponse.status === 'fulfilled' && serverResponse.value.ok;
      const zapierSuccess = zapierResponse.status === 'fulfilled' && zapierResponse.value.ok;

      if (serverSuccess || zapierSuccess) {
        setIsSubmitting(false);
        setSubmitted(true);
        
        setTimeout(() => {
          fullNameRef.current.value = "";
          phoneRef.current.value = "";
          reasonRef.current.value = "";
          setSubmitted(false);
          setErrors({
            fullName: '',
            phone: '',
            reason: ''
          });
          setAgreed(false);
          closeForm();
        }, 3000);
      } else {
        throw new Error('Both submissions failed');
      }
    } catch (error) {
      alert("התרחשה שגיאה, אנא נסו שוב מאוחר יותר");
      console.error('Error submitting form:', error);
      setIsSubmitting(false);
    }
  };

  // טעינת התמונה
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImageLoaded(true);
    };
    img.onerror = () => {
      setImageLoaded(true);
    };
    img.src = racheli;
  }, []);

  // מעקב אחרי מיקום העכבר עבור אפקט הגרדיאנט
  useEffect(() => {
    if (!imageLoaded) return;
    
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [imageLoaded]);

  // מעקב אחרי גלילה עבור אפקט סיבוב התמונות
  useEffect(() => {
    if (!imageLoaded) return;
    
    const handleScroll = () => {
      const scrollY = window.scrollY;
      
      if (bgImageTopRef.current) {
        bgImageTopRef.current.style.transform = `rotate(${-15 + scrollY * 0.05}deg)`;
      }
      
      if (bgImageBottomRef.current) {
        bgImageBottomRef.current.style.transform = `rotate(${20 - scrollY * 0.03}deg)`;
      }
    };
    
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [imageLoaded]);

  if (!imageLoaded) {
    return <Loader />;
  }

  return (
    <>
      <div className={styles.container}>
        {/* תמונות רקע מטושטשות עם אפקט סיבוב */}
        {/* <div 
          ref={bgImageTopRef}
          className={styles.bgImageTop}
        ></div>
        <div 
          ref={bgImageBottomRef}
          className={styles.bgImageBottom}
        ></div> */}
        
        {/* גרדיאנט אינטראקטיבי */}
        <div 
          className={styles.gradientBackground} 
          style={{
            background: `radial-gradient(
              circle at ${mousePosition.x}px ${mousePosition.y}px,
              rgba(248, 249, 250, 0.8),
              rgba(233, 236, 239, 0.4) 40%,
              transparent 70%
            )`
          }}
        />
        
        <div className={styles.intro}>
          {/* Header with Glass Effect */}
          <div className={styles.mainTextContainer}>
            <div className={styles.mainTextInner}>
              <p className={styles.mainText}>
                לאחר שהובילה מאות נשים לקריירה רווחית בתחום <br/> והוציאה אלפי לקוחות מרוצות <br/> רחלי לוי מציגה
              </p>
            </div>
          </div>
          
          {/* Main Title */}
          <div className={styles.titleContainer}>
            <h1 className={styles.mainTitle}>
              הדרך להפוך למומחית מיקרובליידינג{' '}
              <span className={styles.underlined}>שבטוחה בעצמה</span>,  להפסיק לעבור ממקום למקום ולעשות סדר בדברים  <span className={styles.underlined}>מההתחלה ועד הסוף</span>
            </h1>
            <p className={styles.subtitle}>
              <span className={styles.highlighted}>הקורס הדיגיטלי המקיף בארץ - מהבסיס עד לפרטים הכי קטנים </span>
                 <span className={styles.highlighted}>*יש אופציה לשלב לימוד פרונטלי*</span>
            </p>
          </div>

          {/* Hero Image */}
          <div className={styles.imageContainer}>
            <img
              src={racheli}
              alt="רחלי לוי"
              className={styles.profileImage}
              fetchPriority="high"
              decoding="async"
              width="600"
              height="800"
            />
          </div>
          
          {/* CTA Button */}
          <div className={styles.buttonContainer}>
            <button 
              className={styles.button} 
              onClick={handleButtonClick}
            >
              רחלי, קחי אותי להרשמה!
            </button>
          </div>
        </div>
      </div>

      {/* Form Overlay */}
      {isFormOpen && (
        <div className={styles.formOverlay} onClick={closeForm}>
          <div className={styles.formModal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.formHeader}>
              <button className={styles.formCloseButton} onClick={closeForm}>
                <FaTimes />
              </button>
            </div>
            
            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <label className={styles.label} htmlFor="fullName">שם מלא</label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  className={`${styles.input} ${errors.fullName ? styles.inputError : ''}`}
                  placeholder="השם המלא שלך"
                  disabled={isSubmitting || submitted}
                  ref={fullNameRef}
                />
                {errors.fullName && <p className={styles.errorText}>{errors.fullName}</p>}
              </div>
              
              <div className={styles.formGroup}>
                <label className={styles.label} htmlFor="phone">מספר טלפון</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  className={`${styles.input} ${errors.phone ? styles.inputError : ''}`}
                  placeholder="050-0000000"
                  disabled={isSubmitting || submitted}
                  ref={phoneRef}
                />
                {errors.phone && <p className={styles.errorText}>{errors.phone}</p>}
              </div>
              
              <div className={styles.formGroup}>
                <label className={styles.label} htmlFor="reason">סיבת הפנייה</label>
                <textarea
                  id="reason"
                  name="reason"
                  rows="4"
                  className={`${styles.textarea} ${errors.reason ? styles.inputError : ''}`}
                  placeholder="סיבת הפנייה"
                  disabled={isSubmitting || submitted}
                  ref={reasonRef}
                />
                {errors.reason && <p className={styles.errorText}>{errors.reason}</p>}
              </div>
              
              {/* תיבת האישור למדיניות הפרטיות */}
              <div style={{ 
                display: "flex", 
                justifyContent: "center", 
                marginTop: "20px",
                marginBottom: "20px"
              }}>
                <label style={{ 
                  direction: "rtl", 
                  fontFamily: "AssistantR", 
                  fontSize: "0.9rem", 
                  textAlign: "right", 
                  display: "flex", 
                  alignItems: "center", 
                  flexWrap: "wrap", 
                  gap: "5px" 
                }}>
                  <input
                    type="checkbox"
                    checked={agreed}
                    onChange={() => setAgreed(!agreed)}
                    style={{ marginLeft: "10px" }}
                    disabled={isSubmitting || submitted}
                  />
                  קראתי את
                  <span onClick={handlePrivacyClick}>
                    <PrivacyPolicy 
                      ownerName="רחלי לוי" 
                      email="rachelilevy.beauty@gmail.com" 
                      domain="https://pedimeniracheli.co.il/" 
                    />
                  </span>
                  ואני מאשר/ת
                </label>
              </div>
              
              <button 
                type="submit" 
                className={`${styles.submitButton} ${isSubmitting ? styles.submitting : ''} ${submitted ? styles.submitted : ''}`}
                disabled={isSubmitting || submitted}
              >
                {isSubmitting ? 'שולח...' : submitted ? 'נשלח בהצלחה!' : 'רחלי, בואי נדבר!'}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default NewFirstScreen;